// extracted by mini-css-extract-plugin
export default {"root":"tabs_root__vV6Mh","list":"tabs_list__j8SBb","panel":"tabs_panel__K0-JE","tab":"tabs_tab__uAhTK"};